<div class="wrapper">
    <app-enterprise-navigation></app-enterprise-navigation>

    <div class="content-wrapper">
        <app-content-transition></app-content-transition>
        <app-enterprise-header title="Wallet Balance"></app-enterprise-header>

        <app-wallet-balance></app-wallet-balance>
    </div>
</div>
